import auth0 from 'auth0-js';

// Configures and returns the Auth0 client. We should make sure that we have only 1 instance of this client per un-refreshed session.
// The Auth0 domain name and client_id is obtained from the environment variables (.env file)

const auth0Client = new auth0.WebAuth({
  clientID: process.env.REACT_APP_AUTH0_CLIENTID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  responseType: 'token id_token',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  redirectUri: window.location.origin,
  scope: 'openid profile email'
});

export default auth0Client;
